import axios from 'axios'
import { store } from '../store'
import config from '../config'

const axiosConfig = {
  timeout: 60000,
  baseURL: config.endpointExport
}

// Create Axios
const service = axios.create(axiosConfig)

// Request
service.interceptors.request.use(config => {
  if (store.getState().user) {
    config.headers['Authorization'] = 'Bearer ' + store.getState().user.firebaseToken;
  }
  // console.log('axios config...,' + JSON.stringify(config))
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// Response
service.interceptors.response.use(
  response => response,
  error => {
    // console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/api/fetch.js